import React, { memo, useCallback } from 'react';
import { TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  Text,
  Icon,
  IconArrowLeft,
  IconDrag,
  Space,
} from '@redlink/components/atoms';

export const PreviewLinkItem = memo(
  ({
    logoName,
    title,
    externalUrl,
    themeIndependent = false,
    dragable = false,
    numberOfLines,
    dragHandle,
  }) => {
    const { styles, colors } = useStyle();
    const onPress = useCallback(() => {
      window.open(externalUrl, '_blank');
    }, [externalUrl]);
    return (
      <TouchableOpacity
        {...{ onPress }}
        activeOpacity={0.6}
        style={[styles.container, themeIndependent && styles.panelContainer]}
      >
        {dragable && (
          <>
            <div {...dragHandle}>
              <IconDrag />
            </div>
            <Space size={15} />
          </>
        )}
        <Icon
          name={logoName}
          color={themeIndependent ? colors.gray23 : colors.subtitle}
        />
        <Text
          numberOfLines={numberOfLines}
          style={[styles.text, themeIndependent && styles.panelText]}
        >
          {title}
        </Text>
        <IconArrowLeft
          color={themeIndependent ? colors.gray23 : colors.title}
        />
      </TouchableOpacity>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  container: {
    flexDirection: 'row',
    paddingVertical: 20,
    paddingHorizontal: 16,
    alignItems: 'center',
    backgroundColor: colors.cardBackground,
    borderRadius: 10,
  },
  panelContainer: {
    backgroundColor: colors.gray7,
  },
  text: {
    flex: 1,
    fontSize: 16,
    // fontWeight: 'bold',
    color: colors.title,
    marginStart: 8,
    textAlign: 'left',
  },
  panelText: {
    color: colors.gray23,
  },
}));
